import { Dispatch } from 'react';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { MasterDataSettingListItem, ProductField } from '../types/master-data-setting-types';
import { AnyAction } from 'redux';

export type MasterDataSettingListParam = {
  sort?: string;
  name?: ProductField;
};

export type CreateMasterDataSettingBody = {
  name: ProductField;
  values: string[];
};

export type UpdateMasterDataSettingBody = {
  values: string[];
};

type MasterDataSettingListResponse = {
  items: MasterDataSettingListItem[];
};

const urlEndPoint = `${ADMIN_URL}/commission/master-data`;

export const fetchMasterDataSettingList = async (
  dispatch?: Dispatch<AnyAction>,
): Promise<MasterDataSettingListItem[]> =>
  apiClient
    .get<MasterDataSettingListResponse>(urlEndPoint)
    .then((response) => response.data.items)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const fetchMasterDataSettingItem = async (
  id: string,
  dispatch?: Dispatch<AnyAction>,
): Promise<MasterDataSettingListItem> =>
  apiClient
    .get<MasterDataSettingListItem>(`${urlEndPoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const fetchMasterDateSettingItemByName = async (
  name: ProductField,
  dispatch?: Dispatch<AnyAction>,
): Promise<MasterDataSettingListItem> =>
  apiClient
    .get<MasterDataSettingListItem>(`${urlEndPoint}/by-name/${name}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const createMasterDataSettingItem = async (
  body: CreateMasterDataSettingBody,
  dispatch?: Dispatch<AnyAction>,
): Promise<void> =>
  apiClient
    .post<void>(`${urlEndPoint}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const modifyMasterDataSettingItem = async (
  id: string,
  body: UpdateMasterDataSettingBody,
  dispatch?: Dispatch<AnyAction>,
): Promise<void> =>
  apiClient
    .put<void>(`${urlEndPoint}/${id}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const deleteMasterDataSettingItem = async (id: string, dispatch?: Dispatch<AnyAction>): Promise<void> =>
  apiClient
    .delete<void>(`${urlEndPoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
